import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { Message } from '../../../subcomponents/message/message';
export var SitePickerMessageType;
(function (SitePickerMessageType) {
    SitePickerMessageType["FailedToLoadData"] = "FailedToLoadData";
})(SitePickerMessageType || (SitePickerMessageType = {}));
export const SitePickerMessage = observer(props => {
    const { messageType, displayText, assets } = props;
    return (_jsx(Message, Object.assign({}, getSitePickerMessageProps(messageType, assets, displayText), { className: 'v-site-picker-message' })));
});
SitePickerMessage.displayName = 'SitePickerMessage';
const getSitePickerMessageProps = (messageType, assets, displayText) => {
    switch (messageType) {
        case SitePickerMessageType.FailedToLoadData:
            return {
                iconName: assets.failedToLoadDataIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
        default:
            return undefined;
    }
};
//# sourceMappingURL=message.js.map